var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#9230C5",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.911 8.19C14.786 8.017 11.806 4 8 4 4.194 4 1.214 8.018 1.089 8.19a.462.462 0 0 0 0 .544c.125.17 3.105 4.19 6.91 4.19 3.807 0 6.787-4.02 6.912-4.19a.461.461 0 0 0 0-.545zM8 12c-2.804 0-5.232-2.667-5.95-3.539C2.766 7.59 5.19 4.923 8 4.923c2.803 0 5.231 2.667 5.95 3.539C13.233 9.334 10.81 12 8 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 5.692a2.772 2.772 0 0 0-2.77 2.77A2.772 2.772 0 0 0 8 11.23a2.772 2.772 0 0 0 2.77-2.77A2.772 2.772 0 0 0 8 5.693zm0 4.616a1.848 1.848 0 0 1-1.846-1.846c0-1.018.828-1.847 1.846-1.847 1.018 0 1.846.829 1.846 1.847A1.848 1.848 0 0 1 8 10.308z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.d8095c70ab579140bf0b85ab82766dc7.svg";
export { ForwardRef as ReactComponent };